/* eslint-disable no-underscore-dangle */
import React from 'react'
import { Typography } from '@mui/material'

function getSignatureType(url) {
  const type = url.replace(/^(.+)PA_AD_(..)_(.+)/, '$2')

  switch (type) {
    case 'RB': return 'Assinatura Digital com Referência Básica (RB)'
    case 'RT': return 'Assinatura Digital com Referência do Tempo (RT)'
    case 'RV': return 'Assinatura Digital com Referências para Validação (RV)'
    case 'RC': return 'Assinatura Digital com Referências Completas (RC)'
    case 'RA': return 'Assinatura Digital com Referências para Arquivamento (RA)'
    default: return 'Assinatura Digital com Tipo não Reconhecido'
  }
}

function getPositionOfFirstSeparator(string) {
  for (let i = 0; i < string.length; i += 1) {
    const beforeThisChar = string.charAt(i - 1)
    const thisChar = string.charAt(i)
    if (thisChar === ',' && beforeThisChar !== '\\') return i
  }
  return 1000
}

function getSignerName(string) {
  const postCN = string.replace(/^(.*)CN=(.+)/, '$2')
  const positionEnd = getPositionOfFirstSeparator(postCN)
  return postCN.substr(0, positionEnd).replace('\\', '')
}

function Signature({ signature }) {
  const oldUrl = signature?.['ds:Object']?.['xades:QualifyingProperties']?.['xades:SignedProperties']?.['xades:SignedSignatureProperties']?.['xades:SignaturePolicyIdentifier']?.['xades:SignaturePolicyId']?.['xades:SigPolicyQualifiers']?.['xades:SigPolicyQualifier']?.['xades:SPURI']?._text
  const newUrl = signature?.Object?.QualifyingProperties?.SignedProperties?.SignedSignatureProperties?.SignaturePolicyIdentifier?.SignaturePolicyId?.SigPolicyQualifiers?.SigPolicyQualifier?.SPURI?._text
  const url = oldUrl || newUrl

  const oldSigner = signature?.['ds:KeyInfo']?.['ds:X509Data']?.['ds:X509SubjectName']?._text
  const newSigner = signature?.['KeyInfo']?.['X509Data']?.['X509SubjectName']?._text
  const signer = oldSigner || newSigner

  const signatureType = getSignatureType(url)
  const signerName = getSignerName(signer)

  return (
    <div className="signature-component">
      <Typography><b>Tipo de Assinatura</b> <span>{signatureType}</span></Typography>
      <Typography><b>Assinante</b> <span>{signerName}</span></Typography>
    </div>
  )
}

export default Signature
